module.exports = {
	"commitCount": 65,
	"commitMembers": [
		{
			"count": 59,
			"authorName": "airyland"
		},
		{
			"count": 1,
			"authorName": "Qiongrong Jiang"
		},
		{
			"count": 1,
			"authorName": "longyuan"
		},
		{
			"count": 1,
			"authorName": "万刚"
		},
		{
			"count": 2,
			"authorName": "greedying"
		},
		{
			"count": 1,
			"authorName": "lichunqiang"
		}
	],
	"commitUniqueCount": 6
};


//////////////////
// WEBPACK FOOTER
// ./en/components/inline-calendar_git_metas.json
// module id = 962
// module chunks = 135